import { Panel } from "../layout/Panel.tsx";
import { MetricCard } from "../viz/MetricCard.tsx";
import { Waveform } from "../viz/Waveform.tsx";
import { metrics } from "../../stores/metrics.ts";

export function CDNPanel() {
  const get = (m: string) => metrics.latest[`fastly:${m}`]?.value;
  return (
    <Panel title="CDN · Fastly · 1s stream" href="https://manage.fastly.com/observability" span="col-span-4">
      <div class="grid grid-cols-3 gap-3">
        <MetricCard label="Hit Ratio" value={get("hit_ratio")} unit="%" digits={1} />
        <MetricCard label="Bandwidth" value={get("bandwidth_gbps")} unit="Gbps" digits={2} />
        <MetricCard label="Origin Err" value={get("origin_error_rate")} unit="%" digits={2} />
      </div>
      <div class="mt-3 h-24">
        <Waveform metric="fastly:hit_ratio" />
      </div>
    </Panel>
  );
}
